import type { QuoteColumnsKey, QuoteItemColumnsKey } from './types';

export const getQuoteItemColumnsKey = (): QuoteItemColumnsKey => [
  'quoteItemColumns',
];

export const getQuoteColumnsKey = (): QuoteColumnsKey => ['quoteColumns'];
